import { render, staticRenderFns } from "./ProjectListPage.vue?vue&type=template&id=35ffec9c&scoped=true&"
import script from "./ProjectListPage.vue?vue&type=script&lang=js&"
export * from "./ProjectListPage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectListPage.vue?vue&type=style&index=0&id=35ffec9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ffec9c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35ffec9c')) {
      api.createRecord('35ffec9c', component.options)
    } else {
      api.reload('35ffec9c', component.options)
    }
    module.hot.accept("./ProjectListPage.vue?vue&type=template&id=35ffec9c&scoped=true&", function () {
      api.rerender('35ffec9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/ProjectListPage.vue"
export default component.exports